import { createContext, useContext } from 'react';
import { IPatient } from '../modules/unsw-fhir/Patient';

export interface PatientContext {
  patient: IPatient | undefined;
  setPatient: (patient: IPatient | undefined) => void;
  getDisplayName: () => string;
  getLastName: () => string;
  getFirstName: () => string;
  getGender: () => string;
  getDateOfBirth: () => string;
  getMrn: () => string;
  isActive: () => boolean;
  error?: string;
  loading?: boolean;
}

const initalContext: PatientContext = {
  patient: undefined,
  isActive: () => false,
  setPatient: () => {},
  getDisplayName: () => '',
  getFirstName: () => '',
  getLastName: () => '',
  getGender: () => '',
  getDateOfBirth: () => '',
  getMrn: () => '',
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatientContext = createContext<PatientContext>(initalContext);

export const usePatient = () => {
  const patient = useContext(PatientContext);

  return patient;
};
